import React, { useContext, useEffect, useState } from 'react';
import NewsItem from './NewsItem/NewsItem';
import { Article } from '../../types/api';
import { useGetAllNewsQuery } from '../../services/newsService';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { replaceNews } from '../../store/NewsSlice';
import classes from './IndustryNewsPage.module.css';
import { ThemeContext } from '../../App';

export default function IndustryNewsPage() {
  const { data: news, error, isLoading } = useGetAllNewsQuery();

  const globalNews: Article[] = useSelector(
    (state: RootState) => state.news.news,
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (news) {
      const fixedNews = news.map((oneNews) => {
        return {
          ...oneNews,
          image: oneNews.image === 'None' ? undefined : oneNews.image,
        };
      });
      dispatch(replaceNews(fixedNews));
    }
  }, [news, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { theme } = useContext(ThemeContext);

  return (
    <div id={classes[theme]} className={classes.container}>
      {isLoading && (
        <h2 className="text-smBigSepTxt md:text-mdBigSepTxt lg:text-lgBigSepTxt text-center pt-vh20-top md:pt-vh40-top pb-vh10-bottom md:pb-vh20-bottom">
          Loading...
        </h2>
      )}

      {news && !error && (
        <h2 className="text-smBigSepTxt md:text-mdBigSepTxt lg:text-lgBigSepTxt text-center pt-vh20-top md:pt-vh40-top pb-vh10-bottom md:pb-vh20-bottom">
          Latest news
        </h2>
      )}
      {error && (
        <h2 className="text-smBigSepTxt md:text-mdBigSepTxt lg:text-lgBigSepTxt text-center pt-vh20-top md:pt-vh40-top pb-vh10-bottom md:pb-vh20-bottom">
          There was an error loading
        </h2>
      )}

      <div className="flex flex-row flex-wrap w-vw90 mx-auto justify-between lg:pb-vh16-bottom">
        {globalNews
          ? globalNews.map((article) =>
              article.title ? (
                <NewsItem
                  key={article.url}
                  image={article.image}
                  url={article.url}
                  title={article.title}
                  author={article.author}
                  description={article.description}
                  published={article.published}
                />
              ) : null,
            )
          : null}
      </div>
    </div>
  );
}
